
import React, { Component } from "react";
import {FaBeer, FaCloud, FaServer, FaPhone, FaUsers } from "react-icons/fa";
import Title from "./Title";
import { Link } from "react-router-dom";


export default class Footer extends Component {
 state = {
    services: [
      {
        icon: <FaCloud />,
        title: "Products",
        info:
          "Cloud , Chatbot Conversations & Messaging platform, Artificial intelligence "
      },
      {
        icon: <FaServer />,
        title: "Resources",
        info:
          "Docs & Guides"
      },
      {
        icon: <FaPhone />,
        title: "How to contact us",
        info:
          "To get in touch with our dedicated support-team call 0780676133 or email talanta@gmail.com"
      },
      {
        icon: <FaUsers />,
        title: "Customers",
        info:
          "Hiring Managers, Recruiters, Talent managers"
      }
    ]
  };
 render() {
    return (
      <section className="services">
        <Title title="talanta" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              
                
              </article>
              
            );
          })}
          
        </div>
        <br/>
          <hr/>
          <br/>
        <p>Talanta 2020 - 2021 | Terms and conditions apply</p>
      </section>
    );
  }
}
